module.exports = __webpack_public_path__ + "img/tasks_red.3dae457b.png";